<template>
  <vs-popup class="vs-con-loading__container user-edit-popup"
            id="popup"
            title="DOWNLOAD REPORT"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(downloadReportDocument)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="from" name="from" rules="required" v-slot="{ errors }">
                <small class="label">From</small>
                <flat-pickr style="display: none"
                            class="w-full"
                            :config="{ dateFormat: 'd/m/Y'}"
                            v-model="from_date"
                            placeholder="Choose Date"
                />
                <flat-pickr
                            class="w-full"
                            :config="{ dateFormat: 'd/m/Y'}"
                            v-model="from_date"
                            placeholder="Choose Date"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="to" name="to" rules="required" v-slot="{ errors }">
                <small class="label">To</small>
                <flat-pickr style="display: none"
                            class="w-full"
                            :config="{ dateFormat: 'd/m/Y'}"
                            v-model="to_date"
                            placeholder="Choose Date"
                />
                <flat-pickr
                            class="w-full"
                            :config="{ dateFormat: 'd/m/Y'}"
                            v-model="to_date"
                            placeholder="Choose Date"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="currencies" name="currencies" rules="" v-slot="{ errors }">
                <small class="label">Account Currency</small>
              <v-select :clearable="true" placeholder="Currency" v-model="selectedCurrency"
                        :options="currencies"                   
                        label="name"
                        :reduce="option => option.value"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Download</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>

  </vs-popup>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import {RepositoryFactory} from "@/repository/RepositoryFactory";
const ReportingRepository = RepositoryFactory.get('reporting')
import 'flatpickr/dist/plugins/monthSelect/style.css'
import vSelect from 'vue-select'
import Utils from "@/mixins/Utils";

export default {
  name: "DownloadReportPopUp",
  data () {
    return {
      open: false,
      endPoint: '',
      date:'',
      to_date: '',
      from_date: '',
      report_file_name: '',
      selectedCurrency: '',
      currencies: [],
    }
  },
  components: {
    flatPickr,
    'v-select': vSelect,
  },
  mixins:[Utils],
  methods:{
    openPopup(end_point, from, to, report_file_name) {
      this.open = true
      if(from && to) {
        this.from_date = from
        this.to_date = to
      }
      this.currencies = this.getDropdownData('account_currency')
      this.endPoint = end_point
      this.report_file_name = report_file_name
    },
    async downloadReportDocument(){
      this.$vs.loading()
      try {
        const response = await ReportingRepository.downloadSalesReportDocument(this.endPoint, `from=${this.from_date}&to=${this.to_date}&account_currency=${this.selectedCurrency ? this.selectedCurrency : ''}`)
        let fileURL = window.URL.createObjectURL(new Blob([response.data]));
        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', `${this.report_file_name} (${this.from_date} - ${this.to_date}).xlsx`);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.open = false
      } catch (e) {

      }
      this.$vs.loading.close()
    }
  },
}
</script>

<style scoped>

</style>
